const DEFAULT_SPATIAL_CONTROLS = {
    rotation: 0,
    pointScale: 100,
    opacity: 82,
    bgBrightness: 0,
    bgContrast: 0,
    bgOpacity: 100,
};

const spatialTranscriptomicsInfos = {
    namespaced: true,
    state: {
        isSpatialStatus: false,
        spatialInfos: {
            image: '',
            shape: [],
            size: 0,
            micronsPerPixel: 1,
            scaleFactor: 1,
        },
        spatialParams: {
            controls: Object.assign({}, DEFAULT_SPATIAL_CONTROLS),
            isFlipped: false,
            isReset: false,
            isReload: false,
        },
        isExistingSpatial: false,  // 判断数据集是否存在空间转录组数据
    },
    mutations: {
        updateSpatialInfos(state, data) {
            state.spatialInfos = JSON.parse(JSON.stringify(data));
        },
        updateSpatialStatus(state, status) {
            state.isSpatialStatus = status;
        },
        updateSpatialParams(state, data) {
            const params = data || {};
            state.spatialParams = {
                controls: Object.assign({}, DEFAULT_SPATIAL_CONTROLS, params.controls || {}),
                isFlipped: Boolean(params.isFlipped),
                isReset: Boolean(params.isReset),
                isReload: Boolean(params.isReload),
            };
        },
        updateIsExistingSpatial(state, status) {
            state.isExistingSpatial = status;
        },
    },
    actions: {
        setSpatialInfosFunction({commit}, data) {
            commit('updateSpatialInfos', data);
        },
        setSpatialStatusFunction({commit}, status) {
            commit('updateSpatialStatus', status);
        },
        setSpatialParamsFunction({commit}, data) {
            commit('updateSpatialParams', data);
        },
        setIsExistingSpatialFunction({commit}, status) {
            commit('updateIsExistingSpatial', status);
        },
    },
};
export default spatialTranscriptomicsInfos;
